import { edgeColorByRelation, edgeLabel, theme } from '../CrossFlowNavigator/style/cyStyle';

export const getNodeBackgroundColor = (el: any) => {
  const g = (el.data('group') || 'default').toLowerCase();
  const stage = (el.data('Stage') || '').toLowerCase();

  if (g === 'bronze' || stage === 'bronze') return '#B38000';
  if (g === 'silver' || stage === 'silver') return '#7A7E97';
  if (g === 'gold' || stage === 'gold') return '#FFC107';
  if (g === 'pipeline') return '#FF7A00';
  if (g === 'cluster') return '#F48FB1';
  if (g === 'notebook') return '#B39DDB';
  if (g === 'app') return '#00BCD4';
  if (g === 'dq') return '#8BC34A';
  if (g === 'recon') return '#03A9F4';

  return '#9E9E9E';
};

export const getNodeLabel = (el: any) => {
  const d = el.data();
  const typeStr = d.AssetType
    ? String(d.AssetType).toUpperCase()
    : d.group
      ? String(d.group).toUpperCase()
      : '';
  const nameStr = d.label || '';
  const regionStr = d.Domain || d.Sector || d.Program || '';

  const lines = [typeStr, nameStr, regionStr].filter(Boolean);
  return lines.join('\n');
};

export const baseStyle: any = [
  {
    selector: 'node',
    style: {
      'background-color': (el: any) => getNodeBackgroundColor(el),
      color: '#ffffff',
      'font-size': 13,
      'font-weight': 500,
      'line-height': 1.4,
      'text-wrap': 'wrap',
      'text-justification': 'left',
      label: (el: any) => getNodeLabel(el),
      'text-valign': 'center',
      'text-halign': 'center',
      shape: 'rectangle',
      padding: '14px',
      width: 'label',
      height: 'label',
      'border-width': 0,
    },
  },
  {
    selector: 'edge',
    style: {
      width: 2,
      'line-color': (el: any) => edgeColorByRelation(el.data('relation'), el.data('context')),
      'target-arrow-color': (el: any) => edgeColorByRelation(el.data('relation'), el.data('context')),
      'target-arrow-shape': 'triangle',
      label: (el: any) => edgeLabel(el.data('relation'), el.data('context')),
      'font-size': 11,
      color: theme.textMuted,
      'curve-style': 'bezier',
      'control-point-distance': (el: any) => 32 * (Number(el.data('__parallelIndex') || 1) - 1),
      'control-point-weight': 0.2,
    },
  },
  { selector: '.search-hit', style: { 'border-color': theme.brand, 'border-width': 4 } },
];
